import React, { useLayoutEffect, useRef } from 'react';

import { ReportRenderer } from '../../components/report-renderer/report-renderer';
import { useReportBuilderContext } from '../../report-builder.context';

// ReportRenderer adds the standard left and right margins to workAreaWidth.
const DASHBOARD_MARGINS = 80;

export const StandaloneReportContent = ({ isDashboard }: { isDashboard: boolean }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const reportRef = useRef<HTMLDivElement | null>(null);
  const { setWorkAreaWidth } = useReportBuilderContext();

  useLayoutEffect(() => {
    const container = containerRef.current;
    if (!isDashboard || !container) {
      return;
    }
    const updateWidth = () => setWorkAreaWidth(Math.max(0, container.clientWidth - DASHBOARD_MARGINS));
    updateWidth();
    const observer = new ResizeObserver(updateWidth);
    observer.observe(container);
    return () => observer.disconnect();
  }, [isDashboard, setWorkAreaWidth]);

  return (
    <div ref={containerRef} style={{ width: '100%', overflowX: 'auto' }}>
      <ReportRenderer containerRef={reportRef} isDashboard={isDashboard} />
    </div>
  );
};
